<template>
  <div class="container">
    <div class="header">
      <span style="color: #333333;font-size: 16px;font-weight: 400;cursor: pointer" @click="$router.go(-1)"><i class="el-icon-arrow-left"></i>返回首页</span>
      <span style="color: #333333;font-weight: 400;font-size: 20px">身份认证</span>
      <span></span>
    </div>
    <div class="content">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item prop="userName">
          <el-input v-model="form.userName" prefix-icon="el-icon-user" placeholder="请输入您的真实姓名"
                    autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="cardId">
          <el-input v-model="form.cardId" prefix-icon="el-icon-postcard" placeholder="请输入身份证号" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button style="width: 100%;background: #DC2325;color: #fff" @click="found('form')">认证</el-button>
        </el-form-item>
        <p style="color:red;">认证机会仅有一次，请您务必认真填写，仔细校对。</p>
      </el-form>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import cookie from "@/api/cookie";

export default {
  name: "index",
  data() {
    return {
      form: {
        userId: cookie.getCookie('userId'),
        userName: "",
        cardId: "",
      },
      rules: {
        userName: [
          {required: true, message: '请输入您的真实姓名', trigger: 'blur'},
        ],
        cardId: [
          {required: true, message: '请输入身份证号', trigger: 'blur'}
        ]
      }
    }
  },
  mounted() {

  },
  methods: {
    found(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // eslint-disable-next-line no-unused-vars
          api.updateUser(this.form).then(res => {
            this.$message.success("身份认证成功！")
            this.form = {}
            this.$router.go(-1)
          })
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 1200px;
  margin: 20px auto;
  height: 663px;
  background: #ffffff;

  .header {
    display: flex;
    justify-content: space-between;
    padding: 20px 10px;
    border-bottom: 1px solid #F0F0F0;
  }

  .content {
    width: 370px;
    margin: 50px auto;
  }
}
</style>
